/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Demoteacher_Goethe17Inputs */

const en__field_enum_demoteacher_goethe17 = /** @type {(inputs: _Field_Enum_Demoteacher_Goethe17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lehrbeauftragte*r der Goethe-Universität`)
};

const de__field_enum_demoteacher_goethe17 = /** @type {(inputs: _Field_Enum_Demoteacher_Goethe17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lehrbeauftragte*r der Goethe-Universität`)
};

/**
* | output |
* | --- |
* | "Lehrbeauftragte*r der Goethe-Universität" |
*
* @param {_Field_Enum_Demoteacher_Goethe17Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_demoteacher_goethe17 = /** @type {((inputs?: _Field_Enum_Demoteacher_Goethe17Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Demoteacher_Goethe17Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_demoteacher_goethe17(inputs)
	return de__field_enum_demoteacher_goethe17(inputs)
});
export { _field_enum_demoteacher_goethe17 as "_field_enum_DEMOTEACHER_GOETHE" }